import React from 'react';

// Funkcja pomocnicza do rem()
const rem = (px: number) => `${px / 16}rem`;

const fontSize = {
  xs: rem(12),
  sm: rem(14),
  base: rem(16),
  lg: rem(18)
};

interface ReportDisclaimerProps {
  className?: string;
}

export const ReportDisclaimer: React.FC<ReportDisclaimerProps> = ({ className }) => {
  return (
    <div 
      style={{
        background: '#FFF9E6',
        border: '1px solid #FFE082',
        borderRadius: rem(12),
        padding: rem(16),
        marginBottom: rem(24),
        display: 'flex',
        gap: rem(12),
        alignItems: 'flex-start'
      }}
      className={className}
    >
      {/* Ikona */}
      <div style={{
        flexShrink: 0,
        width: rem(24),
        height: rem(24),
        borderRadius: '50%',
        background: '#FFC107',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#FFFFFF',
        fontSize: fontSize.sm,
        fontWeight: 600
      }}>
        !
      </div>
      
      {/* Treść */}
      <div style={{ flex: 1 }}>
        <div style={{
          fontSize: fontSize.sm,
          fontWeight: 600,
          color: '#1A1A1A',
          marginBottom: rem(6)
        }}>
          Uwaga
        </div>
        <div style={{
          fontSize: fontSize.sm,
          color: '#666666',
          lineHeight: 1.5
        }}>
          Prezentowane raporty i stany choroby są klasyfikacją użytkową, stworzoną do obserwacji zmian i trendów w czasie. Nie stanowią diagnozy medycznej i opierają się wyłącznie na danych wprowadzonych przez Ciebie.
        </div>
      </div>
    </div>
  );
};

// Stała dla tooltipów (skrócona wersja)
export const REPORT_TOOLTIP_DISCLAIMER = 'To wskaźnik pomocniczy oparty na Twoich wpisach. Nie zastępuje oceny lekarza.';
